import { useCallback, useEffect, useState } from 'react';

import { supabase } from '../lib/supabase';

/**
 * Nazwy czujników organizacji (`device_id → device_name`) z migawki
 * `neurosense_sensor_latest` — tej samej, którą czyta ekran „Aplikacje
 * i urządzenia". Feed zdarzeń pisze dzięki temu „CHŁODNIA-PIEKARNIA:
 * wilgotność 53,1%” zamiast `sensor-531179`.
 *
 * Brak nazwy nie jest błędem: czujnik świeżo sparowany może jej jeszcze nie
 * mieć, wtedy czytelnik pokazuje identyfikator. Błąd zapytania idzie do
 * konsoli, a mapa zostaje pusta — feed dalej działa, tylko po identyfikatorach.
 */
export function useDeviceNames(organizationId?: string | null) {
  const [mapa, setMapa] = useState<Record<string, string>>({});

  useEffect(() => {
    if (!organizationId) {
      setMapa({});
      return;
    }
    let aktywne = true;
    supabase
      .from('neurosense_sensor_latest')
      .select('device_id, device_name')
      .eq('organization_id', organizationId)
      .then(({ data, error }) => {
        if (!aktywne) return;
        if (error) {
          console.error('Nazwy urządzeń nie odpowiedziały:', error);
          return;
        }
        const wpisy = ((data ?? []) as Array<{ device_id: string; device_name: string | null }>)
          .filter((r) => r.device_id && r.device_name)
          .map((r) => [r.device_id, r.device_name as string] as const);
        setMapa(Object.fromEntries(wpisy));
      });
    return () => {
      aktywne = false;
    };
  }, [organizationId]);

  const nazwaUrzadzenia = useCallback((deviceId: string) => mapa[deviceId], [mapa]);

  return { nazwaUrzadzenia, mapa };
}
